export const SET_OFS = 'SET_OFS'

export const mutations = {
  [SET_OFS](state, ofs) {
   state.ofs = ofs
  }
}
